module.exports = __webpack_public_path__ + "static/media/media6.39c292b5.jpg";